export const customModuleStyles = {
    "Style-1":{
      "heroModule": {
         "subClasses":[
            {
               "className":".hero-home",
               "styles":
                  {
                     "tab":[
                        "height: 900px !important;",
                     ],
                     "mobile":[
                        "height: 439px !important;",
                        "font-size: 40px !important;",
                     ]
                  }
            },
            {
               "className":".hero-home .concierge-hero-image > div",
               "styles":
                  {
                     "tab":[
                        "height: 900px !important;",
                     ],
                     "mobile":[
                        "height: 439px !important;",
                     ]
                  }
            },
            {
               "className":".ext-hero .concierge-hero-content-wrapper h1",
               "styles":
                  {
                     "mobile":[
                        "font-size: 40px !important;",
                     ]
                  }
            }
         ]
      },
       "articleContainer": {
        "subClasses":[
            {
               "className":".article-container",
               "styles":
                  {
                     "desktop":[
                        "margin-top: 0 !important;",
                        "margin-bottom: 0 !important;"
                     ],
                     "tab":[
                        "margin-top: 0 !important;",
                        "margin-bottom: 0 !important;"
                     ]
                  }
            }
        ]
       },
       "quoteModule-spotlight": {
         "subClasses":[
            {
               "className":".quote-module",
               "styles":
                  {
                     "desktop":[
                        "max-width: 1046px !important;",
                     ]
                  }
            },
             {
                "className":".quote-module.quote-module-centered h2.cms-typo",
                "styles":
                   {
                      "tab":[
                        "font-weight: 500 !important;",
                        "font-size: 44px !important;",
                        "line-height: 54px !important;",
                        "font-style: normal !important;"
                      ]
                   }
             },
         ]
        },
        "quoteModule": {
         "subClasses":[
            {
               "className":".quote-module",
               "styles":
                  {
                     "desktop":[
                        "max-width: 1076px !important;",
                        "padding: 2px 32px 68px !important;"
                     ],
                     "tab":[
                        "max-width: 1076px !important;",
                        "padding: 10px 32px 64px !important;"
                     ],
                     "mobile":[
                        "max-width: 1076px !important;",
                        "padding: 10px 24px 53px !important;"
                     ]
                  }
            }
         ]
        },
       "productIntegrationModule-spotlight": {
            "subClasses":[
                {
                    "className": ".product-integration-panel .container",
                    "styles": 
                    {
                        "desktop":[
                            "max-width: 1046px !important;",
                            "padding-left: 15px !important;",
                            "padding-right: 15px !important;",
                            "padding-top: 72px !important;",
                            "padding-bottom: 76px !important;",
                        ],
                        "tabmedium":[
                            "max-width: 514px !important;",
                            "padding-left: 15px !important;",
                            "padding-right: 15px !important;",
                            "padding-top: 47px !important;",
                            "padding-bottom: 29px !important;"
                         ],
                         "mobile":[
                            "max-width: 348px !important;",
                            "padding-left: 24px !important;",
                            "padding-right: 24px !important;",
                            "padding-top: 32px !important;",
                            "padding-bottom: 0 !important;"
                         ],
                    }
                },
                {
                  "className": ".container .product-integration-panel-image",
                  "styles": {
                        "tab":[
                           "max-width: 368px !important;",
                           "margin: 0 auto !important;"
                        ],
                        "mobile":[
                           "max-width: calc(100% - 32px) !important;"
                        ]
                     }
                },
                {
                  "className": ".container .product-integration-panel-image.theme2coloredbars",
                  "styles": {
                        "tab":[
                           "max-width: 100% !important;",
                           "margin: 0 auto !important;"
                        ],
                        "mobile":[
                           "max-width: calc(100% - 32px) !important;"
                        ]
                     }
                },
                {
                    "className": ".product-integration-panel-title",
                    "styles":
                    {
                        "desktop": [
                            "padding: 20px 0 20px 57px !important;"
                        ],
                        "tab":[
                            "padding: ;"
                         ],
                    }
                },
                {
                  "className": ".product-integration-panel-title h2.cms-typo",
                  "styles":
                     {
                      "tabmedium":[
                           "font-weight: 500 !important;",
                           "font-size: 40px !important;",
                           "line-height: 46px !important;",
                           "text-align: center !important;"
                       ],
                  }
              },
              {
               "className": ".product-integration-panel-title p.cms-typo",
               "styles":
                  {
                   "tabmedium":[
                        "font-weight: 300 !important;",
                        "font-size: 18px !important;",
                        "line-height: 27px !important;",
                        "text-align: center !important;"
                    ],
                    "mobile": [
                     "font-weight: 300 !important;",
                     ]
               }
           },
            {
               "className": ".product-integration-panel-title-mobile a",
               "styles":
                  {
                     "tab":[
                        "width: fit-content !important;",
                        "margin: 0 auto !important;"
                     ]
               }
            },
            {
               "className": ".product-integration-panel-title p.cms-typo",
               "styles":
                  {
                     "desktop":[
                        "font-weight: normal !important;",
                        "font-size: 18px !important;",
                        "line-height: 27px !important;"
                     ]
               }
            },
            {
               "className": ".product-integration-panel-title",
               "styles":
                  {
                     "tab": [
                        "padding-top: 40px !important;"
                     ],
                     "mobile": [
                        "padding-top: 15px !important;"
                     ]
                  }
            },
            {
               "className": ".product-integration-panel-title-mobile",
               "styles":
                  {
                     "tab": [
                        "margin-top: 20px !important;",
                        "padding-bottom: 40px !important;"
                     ],
                     "mobile": [
                        "margin-top: 15px !important;",
                        "padding-bottom: 30px !important;"
                     ]      
                  }
            },
            {
               "className": ".product-integration-panel-image.theme2coloredbars .colorbar-wrapper .colorbar-right",
               "styles":
                  {
                     "tab": [
                        "width: 154px !important;",
                        "height: 64px !important;",
                        "top: 19px !important;",
                        "right: 13px !important;"
                     ],
                     "mobile": [
                        "width: 98px !important;",
                        "height: 38px !important;",
                        "top: 9px !important;",
                        "right: 9px !important;"
                     ]      
                  }
            },
            {
               "className": ".product-integration-panel-image.theme2coloredbars .colorbar-wrapper .colorbar-left",
               "styles":
                  {
                     "tab": [
                        "width: 67px !important;",
                        "height: 154px !important;",
                        "bottom: 17px !important;",
                        "left: 18px !important;"
                     ],
                     "mobile": [
                        "width: 41px !important;",
                        "height: 120px !important;",
                        "bottom: 11px !important;",
                        "left: 8px !important;"
                     ]      
                  }
            },
            {
               "className": ".product-integration-panel-title.theme2coloredbars",
               "styles":
                  {
                     "desktop": [
                        "padding: 20px 0 20px 8px !important;",
                     ],
                     "tab": [
                        "padding: 10px 20px 0 !important;",
                     ],
                     "mobile": [
                        "padding: 0 20px 0 !important;",
                     ]    
                  }
            },
            {
               "className": ".product-integration-panel-title h2.cms-typo",
               "styles":
                  {
                     "desktop": [
                        "margin-bottom: 14px !important;"
                     ],
                     "tab": [
                        "margin-bottom: 18px !important;",
                     ],
                     "mobile": [
                        "margin-bottom: 15px !important;",
                        "margin-top: 16px !important;"
                     ]    
                  }
            },
            {
               "className": ".product-integration-panel-title p.cms-typo",
               "styles":
                  {
                     "desktop": [
                        "margin-bottom: 16px !important;"
                     ],
                     "tabmedium": [
                        "margin-bottom: 0 !important;",
                     ]  
                  }
            }
         ]
       },
       "featureBlockModule":{
          "subClasses":[
             {
                "className":"h2.cms-typo",
                "styles":
                   {
                      "desktop":[
                        "font-size: 42px !important;",
                        "line-height: 56px !important;",
                        "margin-bottom: 39px !important;",
                        "margin-top: 28px !important;"
                      ],
                      "tab":[
                         "font-size: 40px !important;",
                         "line-height: 46px !important;",
                         "margin-top: 26px !important;",
                         "margin-bottom: 34px !important;",
                      ],
                      "mobile":[
                         "font-size: 40px !important;",
                         "line-height: 46px !important;",
                         "margin-top: 21px !important;",
                         "margin-bottom: 34px !important;"
                      ]
                   }
             },
             {
                "className": ".article-text-body .cms-typo.article-body-content.featureBlockModuleArticle",
                "styles":
                    {
                        "desktop":[
                            "margin-top: 21px !important;",
                            "margin-bottom: 23px !important;"
                        ],
                        "tab":[
                            "margin-top: 12px !important;",
                            "margin-bottom: 13px !important;"
                        ],
                        "mobile":[
                           "margin-top: 12px !important;",
                           "margin-bottom: 13px !important;"
                       ]
                }
             },
             {
                "className": ".article-text-body .article-body-content p",
                "styles":
                    {
                        "desktop":[
                            "font-size : 18px !important;",
                            "line-height : 27px !important;",
                            "font-weight: normal !important;",
                        ],
                        "mobile": [
                           "font-weight: 300 !important;",
                        ]
                    }
             },
             {
               "className": ".article-text-body-wrapper",
               "styles":
                  {
                     "tab":[
                        "margin: 0 20px !important;"
                     ],
                     "mobile":[
                        "margin: 0 16px !important;"
                     ]
                  }
             },
             {
               "className": ".image-background-container-wrapper",
               "styles":
                  {
                     "desktop":[
                        "display: flex !important;"
                     ]
                  }
             }
          ]
       },
       "textModule":{
          "subClasses":[
             {
                "className":".article-text-body",
                "styles":
                   {
                      "desktop":[
                         "margin: 18px 0 22px !important;"
                      ],
                      "tab":[
                         "margin: 16px 0 13px !important;"
                      ],
                      "mobile":[
                         "margin: 5px 0 13px !important;"
                      ]
                   }
             },
             {
                "className":".article-text-body h2.cms-typo",
                "styles":
                  {
                     "desktop":[
                         "font-size: 18px !important;",
                         "line-height: 27px !important;",
                         "font-weight: bold !important;",
                         "margin-top: 0 !important;",
                         "margin-bottom: 0 !important;"
                     ],
                     "mobile": [
                        "font-weight: 700 !important;"
                     ]
                  }
             },
             {
                "className": ".article-text-body.textModuleArticle .cms-typo.article-body-content",
                "styles":
                  {
                     "desktop":[
                           "margin-top: 0 !important;",
                           "margin-bottom: 0 !important;"
                     ],
                     "tab":[
                           "margin-top: 0 !important;",
                           "margin-bottom: 0 !important;"
                     ]
                  }
             },
             {
                "className":".article-body-content p",
                "styles":
                  {
                     "desktop":[
                        "font-size : 18px !important;",
                        "line-height : 27px !important;",
                     ],
                     "mobile": [
                        "font-weight: 300 !important;"
                     ]
                  }
             },
             {
               "className": ".article-text-body-wrapper",
               "styles":
                  {
                     "tab":[
                        "margin: 0 20px !important;"
                     ],
                     "mobile": [
                        "margin: 0 16px !important;"
                     ]
                  }
             }
          ]
      },
      "doubleImageModule": {
         "subClasses":[
            {
               "className":".double-image-panel-wrapper",
               "styles":
                  {
                     "tab":[
                        "padding-left: 20px !important;",
                        "padding-right: 20px !important;"
                     ],
                     "mobile":[
                        "padding-left: 16px !important;",
                        "padding-right: 16px !important;"
                     ]
                  }
            }
         ]
      },
      "contentTileModule-spotlight": {
         "subClasses":[
            {
               "className":".content-tile",
               "styles":
                  {
                     "desktop":[
                        "padding-top: 64px !important;",
                        "padding-bottom: 64px !important;"
                     ],
                     "tab":[
                        "padding-top: 40px !important;",
                        "padding-bottom: 35px !important;",
                        "padding-left: 52px !important;",
                        "padding-right: 52px !important;"
                     ],
                     "mobile":[
                        "padding-bottom: 111px !important;",
                        "padding-left: 40px !important;",
                        "padding-right: 0 !important;"
                     ]
                  }
            },
            {
               "className":".content-tile.theme2-coloredbars",
               "styles":
                  {
                     "desktop":[
                        "padding-top: 50px !important;",
                        "padding-bottom: 41px !important;"
                     ],
                     "tab":[
                        "padding-top: 40px !important;",
                        "padding-bottom: 35px !important;",
                        "padding-left: 52px !important;",
                        "padding-right: 52x !important;"
                     ],
                     "mobile":[
                        "padding-bottom: 111px !important;",
                        "padding-left: 40px !important;",
                        "padding-right: 0 !important;"
                     ]
                  }
            },
            {
               "className":".content-tile.with-title-spacing",
               "styles":
                  {
                     "desktop":[
                        "padding-top: 38px !important;",
                        "padding-bottom: 41px !important;"
                     ],
                     "tab":[
                        "padding-top: 28px !important;",
                        "padding-bottom: 35px !important;",
                        "padding-left: 52px !important;",
                        "padding-right: 52x !important;"
                     ],
                     "mobile":[
                        "padding-bottom: 111px !important;",
                        "padding-left: 40px !important;",
                        "padding-right: 0 !important;"
                     ]
                  }
            },
            {
               "className":".content-tile p",
               "styles":
                  {
                     "desktop":[
                        "font-size : 18px !important;",
                        "line-height : 27px !important;",
                        "font-weight: normal !important;",
                        "font-style: normal !important;"
                     ],
                     "mobile": [
                        "font-weight: 300 !important;"
                     ]
                  }
            },
            {
               "className":".content-tile p.txtBold",
               "styles":
                  {
                     "desktop": [
                        "font-weight: 700 !important;",
                     ],
                     "mobile": [
                        "font-weight: 700 !important;",
                     ]
                  }
            },
            {
               "className":".content-tile .background-container .background-stripe",
               "styles":
                  {
                     "mobile": [
                        "left: -40px !important;",
                     ]
                  }
            },
            {
               "className":".content-tile h2",
               "styles":
                  {
                     "desktop": [
                        "margin-bottom: 42px !important;"
                     ],
                     "tab": [
                        "margin-bottom: 32px !important;"
                     ]
                  }
            }
         ]
      },
      "contentTileModule": {
         "subClasses":[
            {
               "className":".content-tile .container",
               "styles":
               {
                  "desktop":[
                     "padding: 50px 32px 40px !important;"
                  ],
                  "tab":[
                     "padding: 50px 32px !important;",
                     "padding-top: 50px !important;",
                     "padding-bottom: 36px !important;"
                  ],
                  "mobile": [
                     "padding: 50px 0 106px 24px !important;"
                  ]
               }
            },
            {
               "className":".content-tile p",
               "styles":
                  {
                     "desktop":[
                        "font-size : 18px !important;",
                        "line-height : 27px !important;"
                     ]
                  }
            },
            {
               "className":".content-tile p.txtBold",
               "styles":
                  {
                     "desktop": [
                        "font-weight: 700 !important;",
                     ],
                     "mobile": [
                        "font-weight: 700 !important;",
                     ]
                  }
            }
         ]
      }
   }
}

export const pageWidthStyles = {
   "narrow body":{
      "textModule":{
         "subClasses":[
            {
               "className":".article-text-body .spotlight-component-wrapper",
               "styles":
                 {
                    "desktop":[
                        "max-width: 635px !important;",
                    ],
                    "tabmedium": [
                        "max-width: 100% !important;",
                        "padding-left: 20% !important;",
                        "padding-right: 20% !important;"
                    ]
                 }
            }
         ]
      },
      "featureBlockModule":{
         "subClasses":[
            {
               "className":".article-text-body .spotlight-component-wrapper",
               "styles":
                 {
                    "desktop":[
                        "max-width: 635px !important;",
                    ],
                    "tabmedium": [
                        "max-width: 100% !important;",
                    ]
                 }
            }
         ]
      },
      "imageModule":{
         "subClasses":[
            {
               "className":".spotlight-component-wrapper.image-background-container-wrapper",
               "styles":
                 {
                    "desktop":[
                        "max-width: 635px !important;",
                    ],
                    "tabmedium": [
                        "max-width: 100% !important;",
                    ]
                 }
            }
         ]
      },
   }
}